import { List } from "@mui/material";
import { FC, ReactNode } from "react";
import { MenuSubheader } from "./MenuSubheader";

interface MenuSectionProps {
  label?: string;
  children: ReactNode;
}

const MenuSection: FC<MenuSectionProps> = ({ label, children }) => (
  <List
    component="nav"
    subheader={label ? <MenuSubheader text={label} /> : null}
  >
    {children}
  </List>
);

export { MenuSection };
